export namespace BoUserEnum {
  export const tabName = Object.freeze({
    admin: 'Admin list',
    adminActivity: 'Admin activity',
  });

}
